// extracted by mini-css-extract-plugin
module.exports = {"block":"Section_block__353a5","blockHeading":"Section_block-heading__2ul7B","blockHeadingText":"Section_block-heading-text__28xRq","blockInner":"Section_block-inner__2iJ73"};